import { useUsers } from './list'
import { type UnsavedUser, type SmallUser, isDefined, isNotEmpty } from '@terros/common'

export type ExistingUsersListProp = {
  unsavedUser: UnsavedUser
}

export type UseExistingUsersResult = {
  users: SmallUser[]
  isLoading: boolean
}

export const useExistingUsers = ({ unsavedUser }: ExistingUsersListProp): UseExistingUsersResult => {
  const unsavedHasClientUserId = isDefined(unsavedUser.clientUserId)
  const { data: activeUsers, isFetching: activeUsersLoading } = useUsers()
  const { data: archivedUsers, isFetching: archivedUsersLoading } = useUsers({ showArchived: true })
  const allUsers: SmallUser[] = activeUsers?.concat(archivedUsers ?? []) ?? []
  const filter: SmallUser[] = allUsers
    .filter((u) => {
      // same email or same first and lastname
      if (
        unsavedUser.firstName &&
        unsavedUser.lastName &&
        u.firstName.toLowerCase().includes(unsavedUser.firstName.toLowerCase()) &&
        u.lastName.toLowerCase().includes(unsavedUser.lastName.toLowerCase())
      )
        return true
      if (unsavedUser.email && u.email.toLowerCase().includes(unsavedUser.email.toLowerCase())) return true
      if (unsavedHasClientUserId && isNotEmpty(u.clientUserId) && u.clientUserId === unsavedUser.clientUserId)
        return true
      return false
    })
    .slice(0, 5)
  return { users: filter, isLoading: activeUsersLoading || archivedUsersLoading }
}
